// Hint — an explainable figure. Wraps its children in a dotted-underlined
// span and shows `text` in the app's Radix tooltip (instant, styled; unlike
// the browser's `title`, which needs a second of hovering the exact spot and
// never shows on touch — nobody found those). Use on every number a person
// might reasonably ask "what is this?" about.
import React from "react";
import { Tooltip, TooltipTrigger, TooltipContent } from "../ui/tooltip";

export default function Hint({ text, side = "top", align = "center", className = "", children, testid }) {
  if (!text) return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={`border-b border-dotted border-page-muted cursor-help ${className}`} data-testid={testid}>{children}</span>
      </TooltipTrigger>
      <TooltipContent side={side} align={align} className="max-w-xs text-left leading-snug">{text}</TooltipContent>
    </Tooltip>
  );
}
